module.exports = __webpack_public_path__ + "img/1515899791.a7596b43.jpg";